import { render, staticRenderFns } from "./CopyableInput.vue?vue&type=template&id=45d9894c"
import script from "./CopyableInput.vue?vue&type=script&lang=js"
export * from "./CopyableInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d9894c')) {
      api.createRecord('45d9894c', component.options)
    } else {
      api.reload('45d9894c', component.options)
    }
    module.hot.accept("./CopyableInput.vue?vue&type=template&id=45d9894c", function () {
      api.rerender('45d9894c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/CopyableInput.vue"
export default component.exports